import { render, staticRenderFns } from "./FormPublishBtn.vue?vue&type=template&id=2365a042"
import script from "./FormPublishBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPublishBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports